<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-29 11:34:03
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-28 18:17:27
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\newPatientmanage\components\UserHeader\index.vue
-->
<template>
  <div class="user-header">
    <div class="top-header">
      <header>
        <div class="user-name">
          <img :src="headerData.photoUrl" />
          <div>
            <el-tooltip class="item" effect="dark" :content="headerData.patientName" placement="top-start"
              v-if="headerData.patientName && headerData.patientName.length > 8">
              <strong>{{ headerData.patientName && headerData.patientName.length > 8 ? headerData.patientName.slice(0, 8) + '……' : headerData.patientName }}</strong>
            </el-tooltip>
            <strong v-else>{{ headerData.patientName }}</strong>
            <!-- <p style="margin:0 20px" v-if="headerData.hospitalName || headerData.doctorTeamName">
              {{headerData.hospitalName}} / {{headerData.doctorTeamName}}</p> -->
          </div>
          <!-- <footer>
            <p v-show="headerData.patientSchemeName"></p>
            <p>{{headerData.patientSchemeName}}</p>
            <span
              v-show="headerData.startTime && headerData.stopTime">{{headerData.startTime}}-{{headerData.stopTime}}</span>
          </footer> -->
        </div>
        <!-- <div class="btn-box">
          <el-button type="primary" size="small" style="background:#1A7BFC;border-color:#1A7BFC"
            @click="acquireClick">获取企微标签</el-button>
          <el-button type="primary" size="small" style="background:#1A7BFC;border-color:#1A7BFC"
            @click="renewalClick">更新企微标签</el-button>
        </div> -->
        <div class="header-right">
          <div class="hidden-dom-wrapper">
            <div class="mark-title">
              <span class="mark-line"></span>
              <span>自定义标签</span>
              <div class="label-btn el-icon-edit" @click="editLabel"></div>
            </div>
            <!-- <ul class="hidden-dom">
              <li v-for="(item,index) in headerData.patientLabellist" :style="{ background : item.colour }" :key="index">
                {{ item.labelName }}
              </li>
            </ul> -->

            <ul v-if="headerData.patientLabellist" class="hidden-dom">
              <!-- <li v-show="headerData.patientLabellist.length > 0" :style="{ background : headerData.patientLabellist[0].colour }" >
                {{ headerData.patientLabellist[0].labelName }}
              </li> -->
              <li v-show="headerData.patientLabellist.length > 0"
                v-for="(item,index) in headerData.patientLabellist.slice(0,8)" :style="{ background : item.colour }"
                :key="index" style="color:#FFFFFF">
                {{ item.labelName }}
              </li>
              <div class="popover-more" @click="iconMoreClick" v-show="headerData.patientLabellist.length > 8"><div><i class="el-icon-more"></i></div></div>
              
              <!-- <el-popover placement="bottom" width="500" trigger="hover" class="popover-more"
                v-show="headerData.patientLabellist.length > 8">
                <div>
                  <div class="popover-title">自定义标签</div>
                  <div class="popover-content">
                    <ul>
                      <li v-for="(item,index) in headerData.patientLabellist" :style="{ background : item.colour }"
                        :key="index" style="color:#FFFFFF">
                        {{ item.labelName }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div slot="reference"><i class="el-icon-more"></i></div>
              </el-popover> -->
            </ul>
          </div>
          <div class="hidden-dom-wrapper">
            <div class="mark-title">
              <span class="mark-line"></span>
              <span>DC系统标签</span>
            </div>
            <ul v-if="userLabList" class="hidden-dom">
              <!-- <li v-show="userLabList.length > 0" style="background:#DFECFE;color:#1A7BFC" >
                {{ userLabList[0] }}
              </li> -->
              <li v-show="userLabList.length > 0" v-for="(item,index) in userLabList.slice(0,8)"
                style="background: #D6F5F1;color:#06AA93" :key="index">
                {{ item }}
              </li>
              <div class="popover-more" @click="iconMoreClick" v-show="userLabList.length > 8"><div><i class="el-icon-more"></i></div></div>
              <!-- <el-popover placement="bottom" width="500" trigger="hover" class="popover-more"
                v-show="userLabList.length > 8">
                <div>
                  <div class="popover-title">用户标签</div>
                  <div class="popover-content">
                    <ul>
                      <li v-for="(item,index) in userLabList" style="background: #D6F5F1;color:#06AA93" :key="index">
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div slot="reference"><i class="el-icon-more"></i></div>
              </el-popover> -->
            </ul>
            <!-- <div class="label-folder-wrapper">
              <span class="folder-btn" v-if="labelFoldStatus" @click="labelFoldStatus = !labelFoldStatus">收起<i
                  class="el-icon-arrow-up"></i></span>
              <span class="folder-btn" v-else @click="labelFoldStatus = !labelFoldStatus">展开<i
                  class="el-icon-arrow-down"></i></span>
            </div> -->
          </div>
        </div>

        <!-- <div class="label-btn el-icon-edit" @click="editLabel"></div> -->
      </header>
    </div>
    <!-- 编辑标签 -->
    <el-dialog :visible.sync="dialogVisible" width="30%">
      <div class="title">患者专属标签编辑</div>
      <div class="title-item">每个患者最多添加100个标签奥～</div>
      <div class="label">
        <ul>
          <li v-for="(item,index) in labelArr" :key="index" :style="{ background : item.colour }">
            {{ item.labelName ? item.labelName : item.name  }}
            <span style="color:#fff;font-size:14px;cursor: pointer;margin-left:5px" class="el-icon-circle-close"
              @click="deleteLable(item,index)"></span>
          </li>
        </ul>
      </div>
      <div class="label-search" v-if="addSearch">
        <div class="search-title">每个患者最多添加100个标签奥～</div>
        <div class="search-form">
          <el-select value-key='id' v-model="searchValue" filterable remote reserve-keyword size="mini"
            placeholder="请输入你要搜索的内容" @change="selectOneChange" :remote-method="remoteMethod">
            <el-option v-for="item in labelClass" :key="item.value" :label="item.name" :value="item"></el-option>
          </el-select>
          <el-select style="width:29%" size='mini' v-model="value" placeholder="请选择标签类别" @change="labelChange">
            <el-option v-for="(item,index) in leftInfo" :key="index" :label="item.type" :value="item.id"></el-option>
          </el-select>
          <el-select style="width:29%" size='mini' v-model="value1" value-key='id' placeholder="请选择标签"
            @change="pushLabelId">
            <el-option v-for="(item,index) in rightInfo" :key="index" :label="item.name" :value="item"></el-option>
          </el-select>
        </div>
      </div>
      <div class="add-label" @click="addSearch = true;addLabelModel=false" v-if="addLabelModel">
        <div>+添加一个标签</div>
      </div>
      <div class="updata-btn">
        <el-button size="mini" style="width:110px;height:32px;" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="mini" style="width:110px;height:32px;" @click="updateForm">保存</el-button>
      </div>
    </el-dialog>

    <el-drawer title="" :visible.sync="drawer" :before-close="handleClose">
      <div class="tag-drawer-box">
        <p class="title-box">标签</p>
        <h5 class="tag">自定义标签</h5>
        <div class="tag-box">
          <div class="popover-content">
            <ul>
              <li v-for="(item,index) in headerData.patientLabellist" :style="{ background : item.colour }" :key="index"
                style="color:#FFFFFF">
                {{ item.labelName }}
              </li>
            </ul>
          </div>
        </div>
        <h5 class="tag">DC系统标签</h5>
        <div class="tag-box">
          <div class="popover-content">
            <ul>
              <li v-for="(item,index) in userLabList" style="background: #D6F5F1;color:#06AA93" :key="index">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

    </el-drawer>

  </div>
</template>




<script>
import { queryUserLabelNameByPatientId } from "@/api/Patientmanagement.js";
import {
  apiLabel_leftData,
  apiLabel_leftData_page,
  apiLabel_InsertPatientLabel
} from "../../../SystemSettings/LabelManage/api/index";
export default {
  name: "UserHeader",
  props: {
    //选中用户的所有信息
    headerData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      labelFoldStatus: false,
      dialogVisible: false,
      addSearch: false,
      leftInfo: [],
      value: "",
      searchValue: "",
      value1: "",
      labelClass: [],
      rightInfo: [],
      labelArr: [],
      addLabelModel: true,
      userLabList: [],
      drawer: false
    };
  },
  created() {
    this.getUserLabelData();
  },
  methods: {
    async getUserLabelData() {
      // this.$route.query.patientId   '1547527055353483265'
      let res = await queryUserLabelNameByPatientId(
        this.$route.query.patientId
      );
      if (res.code == 0) {
        this.userLabList = res.data;
        // this.userLabList = ['1','2','2','2','2','2','2','2','2','2','2','2','2','2','2','2','2','2','2','2','2','2']
      }
    },
    //远程搜索
    remoteMethod(val) {
      apiLabel_leftData_page({
        redundant: val,
        current: 1,
        size: 99
      }).then(res => {
        this.labelClass = res.data.records;
      });
    },
    //搜索
    editLabel() {
      this.searchValue = "";
      this.value = "";
      this.value1 = "";
      this.labelArr = [];
      if (this.headerData.patientLabellist) {
        this.headerData.patientLabellist.forEach(item => {
          this.labelArr.push(item);
        });
      }
      this.addSearch = false;
      this.dialogVisible = true;
      this.addLabelModel = true;
      apiLabel_leftData({
        parentId: 0
      }).then(res => {
        this.leftInfo = res.data;
      });
    },
    //下拉框change 事件
    labelChange(val) {
      apiLabel_leftData({
        parentId: val
      }).then(res => {
        this.rightInfo = res.data;
      });
    },
    pushLabelId(val) {
      if (this.labelArr.length >= 100) {
        this.$message.error("每个患者最多添加100个标签奥～");
        this.value1 = null;
      } else {
        this.labelArr.push(val);
      }
    },
    selectOneChange(val) {
      let flag = false;
      this.labelArr.forEach((item, index) => {
        if (item.labelName == val.name) {
          flag = true;
        }
      });
      console.log(flag, "flag");
      if (this.labelArr.length >= 100) {
        this.searchValue = null;
        this.$message.error("每个患者最多添加100个标签奥～");
        return false;
      } else if (flag) {
        this.$message.error("已经选择过相同的标签，请重新选择");
        this.searchValue = null;
        return false;
      } else {
        this.labelArr.push(val);
      }
    },
    //删除标签
    deleteLable(item, index) {
      if (item.source == 2) {
        this.$confirm("请确认，是否对当前标签进行删除", "该标签为医生添加", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        }).then(() => {
          this.labelArr.splice(index, 1);
        });
      } else {
        this.$confirm("请确认，是否对当前标签进行删除", "确认信息", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        }).then(() => {
          this.labelArr.splice(index, 1);
        });
      }
    },
    //保存按钮
    updateForm() {
      if (this.labelArr.length > 100) {
        this.dialogVisible = false;
        this.$message.error("每个患者最多添加100个标签奥～");
        return false;
      }
      let upArr = [];
      this.labelArr.forEach(item => {
        if (item.labelId) {
          upArr.push(item.labelId);
        } else {
          upArr.push(item.id);
        }
      });
      apiLabel_InsertPatientLabel({
        labelId: upArr,
        wholeCourseId: this.headerData.wholeCourseId,
        patientId: this.$route.query.patientId
      }).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.dialogVisible = false;
          this.$parent.initData(
            this.headerData.patientArchivesRightVO.patientId
          );
        } else {
          this.$message.error(res.message);
        }
      });
    },
    acquireClick() {
      //获取企业微信标签
      this.$confirm(
        "操作执行后将从企业微信标签库中获取最新的标签数据，是否继续？",
        "确认信息",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "是",
          cancelButtonText: "否",
          customClass: "message-confirm-style"
        }
      )
        .then(() => {})
        .catch(() => {});
    },
    renewalClick() {
      //更新企业微信标签
      this.$confirm(
        "操作执行后将向企业微信标签库中发送最新自定义标签数据，是否继续？",
        "确认信息",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "是",
          cancelButtonText: "否",
          customClass: "message-confirm-style"
        }
      )
        .then(() => {})
        .catch(() => {});
    },
    handleClose(){
      this.drawer = false;
    },
    iconMoreClick(){
      this.drawer = true;
    }
  }
};
</script>



<style scoped lang="less">
.user-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  // padding-bottom:10px;
  img {
    height: 54px;
    width: 54px;
    object-fit: cover;
    margin-right: 16px;
    border-radius: 50%;
  }
  .top-header {
    flex: 1;
    header {
      display: flex;
      align-items: center;
      position: relative;
      .user-name {
        display: flex;
        width: 150px;
        align-items: center;
      }
      strong {
        color: #333333;
        font-size: 14px;
        line-height: 24px;
      }
      p {
        font-size: 12px;
        color: #595959;
        // margin:0 20px;
        display: inline-block;
      }
      ul {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        padding-right: 15px;
        li {
          padding: 0 7px;
          line-height: 22px;
          min-width: 54px;
          text-align: center;
          background: #eff6ff;
          border-radius: 12px;
          border: 1px solid #e9f2ff;
          color: #1a7bfc;
          font-size: 10px;
          margin-right: 10px;
          color: #fff;
        }
        li:last-child {
          margin: 0;
        }
      }
      .header-right {
        height: 68px;
        overflow: auto;
        flex: 1;
      }
      .hidden-dom-wrapper {
        display: flex;
        // align-items: center;
        .mark-line {
          display: inline-block;
          width: 2px;
          height: 10px;
          background: #1a7bfc;
          border-radius: 1px;
          margin-right: 4px;
          // margin-top: 15px;
        }
        .mark-title {
          font-size: 12px;
          font-weight: 600;
          color: #333333;
          line-height: 17px;
          margin-right: 15px;
          padding-top: 12px;
          width: 100px;
        }
        // .label-folder-wrapper {
        //   font-size: 12px;
        //   color: #333333;
        //   .folder-btn {
        //     cursor: pointer;
        //   }
        // }
      }
      .hidden-dom {
        flex: 1;
        li {
          max-width: calc(25% - 10px);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-top: 10px;
        }
        li:last-child {
          margin-top: 10px;
        }
      }
      .label-btn {
        // position: absolute;
        // right: 0;
        height: 22px;
        width: 22px;
        background: #f2f7fe;
        border-radius: 50%;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        color: #1a7bfc;
        font-size: 14px;
        cursor: pointer;
        line-height: 22px;
        text-align: center;
      }
    }
    footer {
      display: flex;
      align-items: center;
      margin-top: 10px;
      p:nth-child(1) {
        width: 6px;
        height: 6px;
        border-radius: 3px;
        background: #1a7bfc;
      }
      p:nth-child(2) {
        color: #1a7bfc;
        font-size: 12px;
        font-weight: 600;
        margin: 0 12px;
      }
    }
  }
  .title {
    font-size: 18px;
    font-weight: bolder;
    text-align: center;
    color: #000;
    margin-bottom: 10px;
  }
  .title-item {
    font-size: 12px;
    text-align: center;
  }
  .label {
    height: 450px;
    overflow-y: auto;
    margin-top: 20px;
    ul {
      display: flex;
      flex-wrap: wrap;
      border-bottom: 1px solid #f0f0f0;
      margin-bottom: 20px;
      li {
        padding: 0 7px;
        line-height: 22px;
        min-width: 54px;
        text-align: center;
        background: #0d5fca;
        border-radius: 12px;
        border: 1px solid #e9f2ff;
        color: #1a7bfc;
        font-size: 10px;
        margin-right: 10px;
        color: #fff;
        margin-bottom: 20px;
      }
      li:last-child {
        margin-right: 0;
        margin-bottom: 20px;
      }
    }
  }
  .label::-webkit-scrollbar {
    width: 5px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 90px;
  }

  .label::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: rgba(0, 0, 0, 0.2);
  }

  .label::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px #ebeef5;
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
  .label-search {
    .search-title {
      color: #666666;
      font-size: 12px;
      margin-bottom: 20px;
      margin-top: 20px;
    }
    .search-form {
      display: flex;
      justify-content: space-between;
    }
  }
  .add-label {
    margin-top: 30px;
    font-size: 12px;
    color: #ccc;
    width: 100%;
    height: 35px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      border: 1px dashed #1a7bfc;
      color: #1a7bfc;
    }
  }
  .updata-btn {
    text-align: center;
    margin-top: 30px;
  }
}
.popover-more {
  background: #eff6ff;
  padding: 5px 10px;
  border-radius: 15px;
  color: #1a7bfc;
  cursor: pointer;
  line-height: 14px;
  height: 24px;
  margin-top: 10px;
}
.el-popover {
  .popover-title {
    font-size: 14px;
    color: #333333;
    font-weight: 500;
    line-height: 22px;
  }

  
}
.popover-content {
    max-height: 360px;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        background: #eff6ff;
        padding: 4px 7px;
        // padding-right: 5px;
        border-radius: 15px;
        color: #1a7bfc;
        margin-right: 10px;
        margin-top: 10px;
        font-size: 12px;

        span {
          cursor: pointer;
        }
      }
    }
  }
  .popover-content::-webkit-scrollbar {
    width: 5px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 90px;
  }

  .popover-content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: rgba(0, 0, 0, 0.2);
  }

  .popover-content::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px #ebeef5;
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
.btn-box {
  width: 120px;
  /deep/.el-button {
    margin-left: 0 !important;
    margin-top: 10px;
  }
}
.tag-drawer-box {
  margin: 0 60px 0 30px;
  .title-box {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    text-align: center;
  }
  .tag {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 15px;
    display: flex;
    margin-top:40px;
  }
  .tag::before {
    content: "";
    display: block;
    width: 4px;
    height: 15px;
    background: #1a7bfc;
    margin-right: 15px;
    margin-top: 2.5px;
  }
}
</style>